import firebase from "firebase/app";

import "firebase/auth";
import "firebase/storage";
import "firebase/functions";
import "firebase/firestore";

// ============================================
// ALGOLIA CONFIGURATION
// ============================================
let algolia = {
  appId: process.env.ALGOLIA_APP_ID || "",
  apikey: process.env.ALGOLIA_API_KEY || "",
  apikeys: process.env.ALGOLIA_SEARCH_KEY || "",
  index: process.env.ALGOLIA_INDEX || "users",
};

// ============================================
// FIREBASE CONFIGURATION
// ============================================
const getFirebaseConfigFromEnv = () => {
  const envConfig = {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.FIREBASE_DATABASE_URL,
    projectId: process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID,
  };

  // Validate required fields
  if (!envConfig.apiKey || !envConfig.authDomain || !envConfig.projectId) {
    console.error("Missing required Firebase environment variables");
    return null;
  }
  
  return envConfig;
};

// Try to get config from environment variables first
let config = getFirebaseConfigFromEnv();

// Fallback configurations MUST be defined in .env files per project standard.
if (!config) {
  console.warn("Firebase config not found in environment variables. Application might not initialize properly.");
  config = {};
}

// ============================================
// STORAGE BUCKET CONFIGURATION
// ============================================
let storageSmallBucket = process.env.STORAGE_SMALL;
let storageLargeBucket = process.env.STORAGE_LARGE;
if (!storageSmallBucket || !storageLargeBucket) {
  console.warn("Storage bucket config omitted from env. Fallback empty.");
}

// ============================================
// STRIPE CONFIGURATION
// ============================================
import patternsMapping from "@/config/patterns-mapping.yaml";
let stripe_public = process.env.STRIPE_PUBLIC_KEY || "";

if (!stripe_public) {
  stripe_public = process.env.AMBIENTE === "development" 
    ? patternsMapping.stripe.test_public_key 
    : patternsMapping.stripe.live_public_key;
}

// Update Algolia config for development
if (process.env.AMBIENTE === "development" && !process.env.ALGOLIA_APP_ID) {
  console.warn("Initializing Algolia empty configs. Provide .env values.");
}

// ============================================
// FIREBASE INITIALIZATION
// ============================================
!firebase.apps.length ? firebase.initializeApp(config) : firebase.app();

// Firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.functions();
const storage = firebase.storage();

// Storage buckets with fallback to main storage
const storagesmall = storageSmallBucket
  ? firebase.app().storage("gs://" + storageSmallBucket)
  : storage;

const storagelarge = storageLargeBucket
  ? firebase.app().storage("gs://" + storageLargeBucket)
  : storage;

const currentUser = auth.currentUser;

// Collections
const usersCollection = db.collection("users");

// Auth Providers
const fbProvider = new firebase.auth.FacebookAuthProvider();
const gProvider = new firebase.auth.GoogleAuthProvider();
const aProvider = new firebase.auth.OAuthProvider("apple.com");

// ============================================
// EXPORTS
// ============================================
export {
  config,
  db,
  storagelarge,
  storagesmall,
  firebase,
  storage,
  stripe_public,
  functions,
  auth,
  algolia,
  currentUser,
  fbProvider,
  gProvider,
  aProvider,
  usersCollection,
};